var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkTypeCategoryUnknown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0V0C24.8366 0 32 7.16344 32 16V16C32 24.8366 24.8366 32 16 32V32C7.16344 32 0 24.8366 0 16V16Z",
    fill: "url(#paint0_linear_908_12603)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2 9.59998C10.3163 9.59998 9.59998 10.3163 9.59998 11.2V20C9.59998 21.3255 10.6745 22.4 12 22.4C13.3255 22.4 14.4 21.3255 14.4 20V11.2C14.4 10.3163 13.6836 9.59998 12.8 9.59998H11.2ZM12 20.8C12.4418 20.8 12.8 20.4418 12.8 20C12.8 19.5581 12.4418 19.2 12 19.2C11.5581 19.2 11.2 19.5581 11.2 20C11.2 20.4418 11.5581 20.8 12 20.8Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 19.394L19.9196 15.4744C20.5444 14.8496 20.5444 13.8365 19.9196 13.2117L18.7882 12.0803C18.1634 11.4555 17.1503 11.4555 16.5254 12.0803L16 12.6058V19.394Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8 22.4H15.2568L20.0568 17.6H20.8C21.6837 17.6 22.4 18.3163 22.4 19.2V20.8C22.4 21.6836 21.6837 22.4 20.8 22.4Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_908_12603",
    x1: -9.96235e-8,
    y1: 23.84,
    x2: 32.9623,
    y2: 20.9115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#065D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#06596E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E3B91"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkTypeCategoryUnknown);
export default __webpack_public_path__ + "static/media/work-type-category-unknown.15c4c814dd5807ada62faef598d0d892.svg";
export { ForwardRef as ReactComponent };